module.exports = __webpack_public_path__ + "media/assets/images/loader-a439d161922d5ee57a96507261fa6d38.svg";